import React from "react";
import { Link } from "react-router-dom";
import { FiHome, FiCalendar, FiArrowLeft, FiSearch } from "react-icons/fi";
import "./Error.css";

const Error = () => {
  return (
    <div className="error-page">
      <div className="error-card">
        
        {/* Animated Badge / Badge Number */}
        <div className="error-badge">
          <span className="error-code">404</span>
          <div className="badge-glow" />
        </div>

        {/* Headline & Description */}
        <h1 className="error-title">LOOKS LIKE YOU'RE OFF THE MAP!</h1>
        <p className="error-subtitle">
          The page or festival experience you’re looking for has moved, ended, or never existed in this bazaar.
        </p>

        {/* Action Buttons */}
        <div className="error-actions">
          <Link to="/home" className="error-btn primary-btn">
            <FiHome className="btn-icon" /> RETURN HOME
          </Link>
          <Link to="/events" className="error-btn secondary-btn">
            <FiCalendar className="btn-icon" /> BROWSE EVENTS
          </Link>
        </div>

        {/* Helpful Shortcut Links */}
        <div className="error-shortcuts">
          <span className="shortcuts-title">POPULAR DESTINATIONS</span>
          <div className="shortcut-links">
            <Link to="/about">About Us</Link>
            <span className="dot">•</span>
            <Link to="/gallery">Gallery</Link>
            <span className="dot">•</span>
            <Link to="/contact">Exhibit With Us</Link>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Error;